import * as React from 'react';
import { connect } from 'react-redux';
import { User } from 'src/store/user/types';
import { ApplicationState } from 'src/store';
import ImagePicker from 'src/components/utils/ImagePicker/ImagePicker';
import { uploadImageAction, removeImageAction } from 'src/store/image/actions';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { url } from 'src';
import { confirmAlert } from 'react-confirm-alert';
import './MyUserManagement.scss';
import { IconPaths } from 'src/icons';
// import { IconPaths } from 'src/icons';

interface Props {
  user: User;
  uploadImage: typeof uploadImageAction;
  removeImage: typeof removeImageAction;
  uploading: boolean;
}

interface State {
  file?: File;
}

class MyUserManagement extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      file: undefined
    };
  }

  onImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      this.setState({ file });
    }
  };

  removeImage = (userId: number) => {
    confirmAlert({
      title: 'Profilbild entfernen',
      message: 'Profilbild wirklich entfernen?',
      buttons: [
        {
          label: 'Entfernen',
          onClick: () => this.props.removeImage(userId)
        },
        {
          label: 'Abbrechen',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  onUpload = () => {
    if (this.state.file) {
      this.props.uploadImage('profile', this.state.file);
    }
  };

  render() {
    const { user, uploading } = this.props;

    return (
      <div className="container">
        <div className="col-8 centered">
          <h1>{user.name} editieren:</h1>
          {user.image && user.image.url && (
            <div
              onClick={this.removeImage.bind(this, user.id)}
              className="imageDeleteHover pointer"
            >
              <div title="Profilbild löschen">
                <img height="60px" src={IconPaths['bin-icon']} />
              </div>
              <img style={{ maxHeight: '150px', width: 'auto' }} src={url + user.image.url} />
            </div>
          )}
          <label>Profilbild auswählen:</label>
          {this.state.file && (
            <img
              src={URL.createObjectURL(this.state.file)}
              style={{
                maxHeight: '200px',
                maxWidth: '100%',
                objectFit: 'cover',
                float: 'left',
                margin: '10px 0 10px 0'
              }}
            />
          )}
          <ImagePicker onChange={this.onImageChange} />
          <button onClick={this.onUpload} style={{ float: 'left', marginTop: '20px' }}>
            Speichern
          </button>
          <LoadingSpinner pending={uploading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, image }: ApplicationState) => ({
  user: auth.data,
  uploading: image.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  uploadImage: (type: string, file: File) => dispatch(uploadImageAction(type, file)),
  removeImage: (userId: number) => dispatch(removeImageAction(userId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyUserManagement);



// WEBPACK FOOTER //
// ./src/pages/Management/MyUserManagement/MyUserManagement.tsx